"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _constants = require("../../constants");

const Checkbox = (0, _core.withStyles)(() => ({
  root: {
    '&:hover, &.Mui-checked:hover': {
      backgroundColor: `${_constants.colours.font}0a`
    },
    '& .MuiTouchRipple-root .MuiTouchRipple-child': {
      backgroundColor: _constants.colours.font
    }
  }
}))(_core.Checkbox);
var _default = Checkbox;
exports.default = _default;